/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BenchmarkSummaryDto } from '../../models/benchmark-summary-dto';

export interface ApiAdminBenchmarksGet$Params {
  modelTypeId?: string;
}

export function apiAdminBenchmarksGet(http: HttpClient, rootUrl: string, params?: ApiAdminBenchmarksGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BenchmarkSummaryDto>>> {
  const rb = new RequestBuilder(rootUrl, apiAdminBenchmarksGet.PATH, 'get');
  if (params) {
    rb.query('modelTypeId', params.modelTypeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BenchmarkSummaryDto>>;
    })
  );
}

apiAdminBenchmarksGet.PATH = '/api/Admin/benchmarks';
